// New responses contain both the limited cloud and the full frequency table.
// Older deliveries can still provide a flat frequency dictionary.
export const getWordCloudData = (response = {}) => ({
    graph: response?.words_graph ?? response?.wordsGraph ?? response ?? {},
    table: response?.words_table ?? response?.wordsTable ?? response ?? {},
});
